<template>
	<div class="indexbg">
		<topbar></topbar>
		<header></header>
		<emallheader></emallheader>
		<div class="clear mt15"></div>
		<!--container 开始-->
		<div class="w1200 bc">
			<!--购物车：开始-->
			<div class="hq-shopping-cart">
				<!--购物流程：开始-->
				<div class="hq-reg-step">
					<ul class="ico">
						<li>
							<p class="item">shopping cart</p>
							<i class="step-count"></i>
						</li>
						<li><span class="line"></span></li>
						<li>
							<p class="item">Submit orders</p>
							<i class="step-count"></i>
						</li>
						<li><span class="line"></span></li>
						<li class="active">
							<p class="item">confirm payment</p>
							<i class="step-count"></i>
						</li>
						<li><span class="line"></span></li>
						<li>
							<p class="item">successfully ordered</p>
							<i class="step-count"></i>
						</li>
					</ul>
				</div>
				<!--购物流程：结束-->

				<div class="contain">
					<div class="box-title">
						<h5 class="f18">order information</h5>
					</div>
					<div class="pv10 f14">
						Total order consumption：
						<span class="f20 co2" v-if="goodsTotalPrice.totalPoint>0">{{ goodsTotalPrice.totalPoint }}point<span v-if="sumAmount>0">+</span></span>
					<span class="f20 co2" v-if="goodsTotalPrice.totalRed>0">{{ goodsTotalPrice.totalRed }}red point<span v-if="sumAmount>0">+</span></span>
					<span class="f20 co2" v-if="goodsTotalPrice.totalBlue>0">{{ goodsTotalPrice.totalBlue }}blue point<span v-if="sumAmount>0">+</span></span>
					<span class="f20 co2" v-if="goodsTotalPrice.totalSpecial>0">{{ goodsTotalPrice.totalSpecial }}special point<span v-if="sumAmount>0">+</span></span>
					<span class="f20 co2" v-if="sumAmount>0">¥{{ sumAmount }}</span>	
					</div>
					<div v-for="order in orderList">
						<ul >
							<ul class="fl w450 co5">
								<li class="pv10">Order number：{{ order.trade_code }}</li>
								<li class="pv10">Transaction date：{{ createTime }}</li>
							</ul>
							<ul class=" fl co5">
								<li class="pv10">Product Name：{{order.goods_name_en }}</li>
								<li class="pv10">Product Quantity：{{order.goods_number}}</li>
							</ul>
						</ul>
					</div>

				</div>
				<div class="contain mt20">
					<div class="box-title">
						<h5 class="f18">Payment option</h5>
					</div>
          <!--<div class="pay_sanfang">
            <div class="dh_yangshi pl0 ml20">
              <ul>
                <li v-on:click="payEmall('yunpay_wx',null)" class="f12"><img src="../../../static/images/weixin_pay.png" /><i class="ico ico_redgou"></i></li>
              </ul>
              <hr style="border: solid 1px #ddd;">
              <ul>
                <li v-on:click="payEmall('sandpay','01000000')" class="f12"><div class="bank_logo PSBC"></div><i class="ico ico_redgou"></i></li>
                <li v-on:click="payEmall('sandpay','01020000')" class="f12"><div class="bank_logo ICBC"></div><i class="ico ico_redgou"></i></li>
                <li v-on:click="payEmall('sandpay','01050000')" class="f12"><div class="bank_logo CCB"></div><i class="ico ico_redgou"></i></li>
                <li v-on:click="payEmall('sandpay','01030000')" class="f12"><div class="bank_logo ABC"></div><i class="ico ico_redgou"></i></li>
                <li v-on:click="payEmall('sandpay','01040000')" class="f12"><div class="bank_logo BOC"></div><i class="ico ico_redgou"></i></li>
                <li v-on:click="payEmall('sandpay','03030000')" class="f12"><div class="bank_logo CEB"></div><i class="ico ico_redgou"></i></li>
                <li v-on:click="payEmall('sandpay','03040000')" class="f12"><div class="bank_logo" style="background-image: url(../../../static/images/bank/HXB.jpg); background-size: contain;"></div><i class="ico ico_redgou"></i></li>
                <li v-on:click="payEmall('sandpay','03050000')" class="f12"><div class="bank_logo CMBC"></div><i class="ico ico_redgou"></i></li>
                <li v-on:click="payEmall('sandpay','03060000')" class="f12"><div class="bank_logo GDB"></div><i class="ico ico_redgou"></i></li>
                <li v-on:click="payEmall('sandpay','04012900')" class="f12"><div class="bank_logo SHBANK"></div><i class="ico ico_redgou"></i></li>
                <li v-on:click="payEmall('sandpay','04030000')" class="f12"><div class="bank_logo BJBANK"></div><i class="ico ico_redgou"></i></li>
              </ul>
            </div>
          </div>-->
          <!--<div class="pay_sanfang">
						<p class="mb15"><input type="radio" name="radio" id="radio" value="" class="mr10 vm" /> 第三方支付</p>
						<div class="dh_yangshi pl0 ml20">
							<ul>
								<li class="f12"><img src="../../../static/images/yinlian_pay.png" /> <i class="ico ico_redgou"></i></li>
								<li class="f12"><img src="../../../static/images/zhifubao_pay.png" /><i class="ico ico_redgou"></i></li>
								<li class="f12"><img src="../../../static/images/weixin_pay.png" /><i class="ico ico_redgou"></i></li>
							</ul>
						</div>
					</div>
					<div class="pay_wangyin">
						<p class="mb15"><input type="radio" name="radio" id="radio" value="" class="mr10 vm" /> 网银支付<span class="co_999 f12">（请确保您选择的银行卡已开通网上支付功能，否则将无法支付成功！）</span></p>
						<div class="dh_yangshi pl0 ml20">
							<ul>
								<li class="f12">
									<div class="bank_logo ABC"></div><i class="ico ico_redgou"></i></li>
								<li class="f12">
									<div class="bank_logo BOC"></div><i class="ico ico_redgou"></i></li>
								<li class="f12">
									<div class="bank_logo CCB"></div><i class="ico ico_redgou"></i></li>
								<li class="f12">
									<div class="bank_logo CMB"></div><i class="ico ico_redgou"></i></li>
							</ul>
						</div>
					</div>-->
					<div class="m30">

						<!--<a v-on:click="payCQ()" style="margin-right: 30px;" class=" w200"><img src="../../../static/images/sqzf.gif"/></a>-->
						<a v-on:click="payCQ('yunpay_zfb')" class=" w200"><img src="../../../static/images/zfbzf.png"/></a>
					</div>
				</div>

			</div>
			<!--购物车：结束-->
			<div id="shadowLayer"></div>
			<div class="clear"></div>
			<div class="mb20 ad-4 mt20"><img src="../../../static/images/footer-ad-1.png" width="1200" height="60"></div>
		</div>
		<!--container 结束-->

		<div class="clear"></div>
		<footermenu></footermenu>
		<footercopyright></footercopyright>

	</div>
</template>

<script>
	import API from "../../../static/api/api.js"
	import { getImgUrl, dateFormat, getValueFromMap, showMoney, parseResult } from "../../../static/js/emallUtils.js"
	import TopBar from '@/components/TopBar'
	import EmallHeader from '@/components/Header'
	import FooterMenu from '@/components/FooterMenu'
	import ShopNav from '@/components/ShopNav'
	import FooterCopyright from '@/components/FooterCopyright'
	import alertConfirm from "../../../static/js/alertConfirm.js"
	import Vue from 'vue'
	import VueRouter from 'vue-router'
	import MintUI from 'mint-ui'
	import 'mint-ui/lib/style.css'
	Vue.use(VueRouter)
	Vue.use(MintUI)

	export default {
		name: 'orderconfirm',
		data() {
			return {
				boList: [],
				tradeCode: '',
				packageCode:'',
				sumAmount: 0,
				createTime: '',
				tradeCodes:'',
				goodsTotalPrice:{
					allAmount: 0,
					totalPoint: 0,
					totalRed: 0,
					totalBlue: 0,
					totalSpecial: 0,
					totalMoney: 0,
					totalExpressAmount: 0,
					brokerDiscountPersent: 0
				},
				orderList:[]
			}
		},
		components: {
			'topbar': TopBar,
			'emallheader': EmallHeader,
			'footermenu': FooterMenu,
			'footercopyright': FooterCopyright,
		},
		methods: {

			getEmallTradeInfo: function(tradeCode) {
				
				var that = this
				API.getTradeInfo(tradeCode, function(ret) {
					var ct = ret.data.gmtCreate + "";
					that.createTime = dateFormat(ct);
				})
			},
			getEmallTradeInfoFromHt: function(tradeCode) {
				var that = this;
				API.getTradeInfo(tradeCode, function(ret) {
					that.sumAmount = ((ret.data.moneyAmount+ret.data.expressAmount	)/100).toFixed(2);
					that.tradeCode = ret.data.tradeCode;
					var ct = ret.data.gmtCreate + "";
					that.createTime = dateFormat(ct);
					that.boList.push(ret.data.orderList[0]);
					var order={};
					order.goods_name = ret.data.orderList[0].goodsName;
					order.goods_name_en = ret.data.orderList[0].goodsNameEn;
					order.goods_number = ret.data.orderList[0].goodsNumber;
					order.trade_code = ret.data.orderList[0].tradeCode;
					that.orderList.push(order);
					that.packageCode=ret.data.packageCode;
						if(ret.data.pointAmount>0 && ret.data.pointType=='point'){
							that.goodsTotalPrice.totalPoint = ret.data.pointAmount * ret.data.goodsNumber+that.goodsTotalPrice.totalPoint;
						}
						if(ret.data.pointAmount>0 && ret.data.pointType=='red'){
							that.goodsTotalPrice.totalRed = ret.data.pointAmount * ret.data.goodsNumber+that.goodsTotalPrice.totalRed;
						}
						if(ret.data.pointAmount>0 && ret.data.pointType=='blue'){
							that.goodsTotalPrice.totalBlue = ret.data.pointAmount * ret.data.goodsNumber+that.goodsTotalPrice.totalBlue;
						}
						if(ret.data.pointAmount>0 && ret.data.pointType=='special'){
							that.goodsTotalPrice.totalSpecial = ret.data.pointAmount * ret.data.goodsNumber+that.goodsTotalPrice.totalSpecial;
						}
				});
			},
			payCQ: function( prodCode) {
				var that = this;
				var packageCode =that.packageCode;
				var tradeCodes =that.tradeCodes;
				if(tradeCodes ==undefined || tradeCodes ==''){
					tradeCodes =that.tradeCode;
				}
			  	alertConfirm.alertConfirm("Are you sure to pay?",function(){	
				  	//API.payPhysicalOrderCQMultiShop(packageCode,tradeCodes,prodCode,function(ret){
						API.payPhysicalOrderMultiShop(packageCode,tradeCodes,'0',prodCode,null,function(ret){
							if(ret.code != null && ret.code == "redirect_pay_page") {
								//
								console.log(ret.data);
								//返回信息在层中进行显示，内容包含新跳转到双乾的支付网关页面
								jQuery("#shadowLayer").html(ret.data);
							}else if(ret.code != null && ret.code == "sandpay") {
                var responseText = ret.data ;
                console.log("杉德支付证书："+responseText);
                paymentjs.createPayment(responseText, function(result, err) {
                  console.log(result);
                  console.log(err.msg);
                  console.log(err.extra);
                });
              }else if(ret.code != null && ret.code == "success"){
								that.$router.push({ name: 'paySuccess', params:{}});
							}else{
								alertConfirm.singleConfirm(ret.msg);
							}
						});
					});
				//});
			},
      //商城自有资金支付
      payEmall: function(prodCode,bankCode) {
        var that = this;
        var packageCode =that.packageCode;
        var tradeCodes =that.tradeCodes;
        if(tradeCodes ==undefined || tradeCodes ==''){
          tradeCodes =that.tradeCode;
        }
        alertConfirm.alertConfirm("Are you sure to pay?",function(){
          API.payPhysicalOrderMultiShop(packageCode,tradeCodes,'0',prodCode,bankCode,function(ret){
            if(ret.code != null && ret.code == "redirect_pay_page") {
              jQuery("#shadowLayer").html(ret.data);
            }	else if(ret.code != null && ret.code == "sandpay") {
              var responseText = ret.data ;
              console.log("杉德支付证书："+responseText);
              paymentjs.createPayment(responseText, function(result, err) {
                console.log(result);
                console.log(err.msg);
                console.log(err.extra);
              });
            }else if(ret.code != null && ret.code == "success"){
              /* 未接支付，暂时屏蔽
               * if(prodCode == "yunpay"){
                that.$router.push({ name: 'paySuccess', params:{}});
              }else if(prodCode == "yunpay_wx"){
                that.$router.push({ name: 'payScanQrcode', params:{code_url:ret.data.code_url,total_fee:ret.data.total_fee,package_code:ret.data.package_code}});
              }*/
             that.$router.push({ name: 'paySuccess', params:{}});
            }else if(ret.code != null && ret.code == 'error'){
              alertConfirm.singleConfirm("Payment failed！"+ret.msg);
            }else{
              alertConfirm.singleConfirm(ret.msg);
            }
          });
        });
      }
		},	
		beforeMount: function() {
			var that = this;
			if(this.$route.params.bos != undefined){
				that.boList = this.$route.params.bos;
			}
			if(this.$route.params.sumAmount != undefined){
				that.sumAmount = this.$route.params.sumAmount.toFixed(2);
			}
			if(this.$route.params.totalPoint != undefined){
				that.goodsTotalPrice.totalPoint = this.$route.params.totalPoint;
			}
			if(this.$route.params.tradeCode!=undefined){
				var tradeCode =  this.$route.params.tradeCode;
				that.tradeCode = tradeCode;
				this.getEmallTradeInfo(tradeCode);
			}
			if(this.$route.query.tradeCode !=undefined){
				var tradeCode = this.$route.query.tradeCode;
				that.getEmallTradeInfoFromHt(tradeCode);
			}
			if(this.$route.params.packageCode !=undefined){
				var packageCode = this.$route.params.packageCode;
				that.packageCode=packageCode;
			}			
			if(this.$route.params.orderList != undefined){
				that.orderList = this.$route.params.orderList;
				var orderList = that.orderList;
				for(var i=0;i<orderList.length;i++){
					if(i>0){
						that.tradeCodes+=",";
					}
					that.tradeCodes += orderList[i].trade_code;
				}
			}			
			
		},
		mounted() {
			 window.scrollTo(0, 0);
		//	this.getEmallTradeInfo(this.tradeCode);
		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/page/order/orderConfirm.vue